<button class="button" type="button" [attr.aria-expanded]="false" (click)="toggleOverlay()">
  <button
    type="button"
    [attr.aria-hidden]="true"
    (click)="onResetClick()"
    [ngClass]="{ close: true, 'is-visible': checkboxCount > 0 }"
  >
    <wb-icon class="close-icon" name="bds/close/24"></wb-icon>
  </button>
  <div class="label">{{ decodedLabel }}</div>
  <wb-counter
    [attr.aria-hidden]="true"
    [value]="checkboxCount"
    variant="tertiary"
    [ngClass]="{ counter: true, 'counter--visible': checkboxCount > 0 }"
  ></wb-counter>
  <wb-icon [attr.open]="open ? true : null" class="caret-icon" name="bds/caret-down/24"></wb-icon>
</button>
<div class="overlay" #template [attr.aria-hidden]="open">
  <ng-content></ng-content>
</div>
